export enum SubscriptionStatus {
  "REGISTERED" = "Registered",
  "RECORDED" = "Recorded",
  "ACTIVE" = "Active",
  "CANCELLED" = "Cancelled",
}
